// TimestampHelper.js
const Helper = {


    // Method to convert Unix timestamp to readable German format
    unixToDateTime(unixTimestamp) {
        const date = new Date(unixTimestamp * 1000);
        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            timeZoneName: 'short'
        };
        return date.toLocaleDateString('de-DE', options);
    }
}

export default Helper;